import { ReactComponent as Alert } from '../../../assets/svg/alert-triangle.svg';
import { ReactComponent as Close } from '../../../assets/svg/CloseDash.svg';
import { ReactComponent as Letter } from '../../../assets/svg/Letter.svg';
import { ReactComponent as Unicorn } from '../../../assets/svg/Unicorn.svg';
import { ReactComponent as Bell } from '../../../assets/svg/warning-w.svg';
import { WelcomeMessageProps } from '../types';


function WelcomeMessage({ message, icon, severity, onClose }: WelcomeMessageProps) {
    let realIcon: React.ReactNode = null;

    switch (icon) {
        case 'unicorn':
            realIcon = <Unicorn width={18} height={17} />;
            break;
        case 'letter':
            realIcon = <Letter width={18} height={17} />;
            break;
        case 'bell':
            realIcon = <Bell width={18} height={17} />;
            break;
        case 'exclamation':
            realIcon = <Alert width={18} height={17} />;
            break;
    }

    let className = '';
    switch (severity) {
        case 'notice':
            className = '';
            break;
        case 'info':
            className = '_beige';
            break;
        case 'warn':
            className = '_badge-warn';
            break;
        case 'err':
            className = '_badge-err';
            break;
        case 'mdlg':
            className = '_stats';
    }

    return (
        <div className={`welcome-message ${className}`}>
            <div className="welcome-message__icon">
                {realIcon}
            </div>
            <p className="welcome-message__copy">
                {message}
            </p>
            <Close
                className="welcome-message__close"
                style={{ cursor: 'pointer' }}
                onClick={onClose}
            />
        </div>
    )
}

export default WelcomeMessage;
